<template>
  <el-row class="login">
    <el-col>
      <el-row>
        <el-col class="login-title-box-col" :sm="{ span: 20, offset: 2 }" :md="{ span: 3, offset: 2 }"
          :lg="{ span: 3, offset: 2 }">
          <img class="login-title-box" src="../static/logo-title.png" alt="">
        </el-col>

        <el-col :sm="{ span: 20, offset: 2 }" :md="{ span: 15, offset: 4 }" :lg="{ span: 9, offset: 8 }">
          <div style="height: 100%;background-color: rebeccapurple;"></div>

          <div class="content-box flex-cloumn">
            <div class="content-box-item flex-cloumn">
              <div class="tab-box flex-row f-align-center f-justify-between">
                <div @click="changeTab(0)" :class="tabIndex == 0 ? '' : 'tab-box-item-actived'"
                  class="tab-box-item flex-row f-align-center flex1" style="padding-right:19px;">
                  <div :class="tabIndex == 0 ? '' : 'tab-box-item-left-actived'"
                    class="tab-box-item-left tab-box-item-left-shadow1 flex-row f-center flex1">
                    学员登录
                  </div>
                  <div :class="tabIndex == 0 ? '' : 'tab-box-item-sanjiao-actived'" class="tab-box-item-sanjiao"></div>
                </div>
                <div @click="changeTab(1)" :class="tabIndex == 1 ? '' : 'tab-box-item-actived'"
                  class="tab-box-item flex-row f-align-center flex1" style="padding-left:19px;">
                  <div :class="tabIndex == 1 ? '' : 'tab-box-item-sanjiao2-actived'" class="tab-box-item-sanjiao2"></div>
                  <div :class="tabIndex == 1 ? '' : 'tab-box-item-left-actived'"
                    class="tab-box-item-left tab-box-item-left-shadow2 f-center flex-row flex1">
                    教练登录
                  </div>
                </div>

              </div>

              <span v-if="noticeMsg" class="notice-box flex-row f-justify-center">{{ noticeMsg }}</span>

              <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">

                <el-form-item prop="username">
                  <span class="login-from-title">用户名</span>
                  <div class="input-box flex-row f-center">
                    <img class="input-box-badge" src="../static/customer.png" alt="">
                    <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入账号">
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item prop="password">
                  <span class="login-from-title">密码</span>
                  <div class="input-box input-box2  flex-row f-center">
                    <img class="input-box-badge" src="../static/lock.png" alt="">
                    <el-input v-model="loginForm.password" :type="pwdType" auto-complete="off" placeholder="请输入密码"
                      @keyup.enter.native="handleLogin">

                    </el-input>
                    <img @click="lookpwd" class="input-box-badge" src="../static/eye-open.png" alt="">

                  </div>

                </el-form-item>
                <div class="pwd-contrl-box flex-row f-justify-between">
                  <el-checkbox v-model="loginForm.rememberMe" text-color="#333333"
                    style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
                  <span @click="forgetPwd" class="pwd-contrl-box-text">忘记密码</span>
                </div>

                <el-form-item style="width:100%;">
                  <el-button class="submit-box" :loading="loading" size="medium" type="primary"
                    @click.native.prevent="handleLogin">
                    <span v-if="!loading">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                  <div style="float: right;" v-if="register">
                    <router-link class="link-type" :to="'/register'">立即注册</router-link>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <!--  底部  -->
          <div class="el-login-footer">
            Copyright © 2024 湖南简易读科技有限公司
          </div>
        </el-col>
      </el-row>


    </el-col>

    <el-dialog title="" :center="true" :visible.sync="dialogForgetPwd" :show-close="false" @open="dialogForgetPwdOpen">

      <el-row slot="title" style="width: 100%;">
        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
          <div class="appraise-popup-title flex-row f-justify-between f-align-center">
            <div style="width:56px;height:56px;"></div>
            <span class="appraise-popup-title-name">提示</span>
            <img @click="dialogForgetPwd = false" src="../static/close.png" alt="">
          </div>

        </el-col>
      </el-row>
      <el-row style="width: 100%;">
        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
          <div class="start-popup-content flex-column f-center">
            <div class="server-box-content flex-row flex-wrap f-justify-center">
              <img class="server-box-content-badge" src="../static/server-badge.png" alt="">
              <div class="server-box-content-textbox flex-column f-justify-center">
                <span>请联系客服</span>
                <span>{{ customerServicePhone }}</span>
                <span>获得更多的帮助</span>
              </div>
            </div>
            <div class="start-popup-content-line"></div>
            <div class="start-popup-content-btnsbox flex-row f-justify-end">
              <div @click="dialogForgetPwd = false">返回</div>
            </div>
          </div>

        </el-col>
      </el-row>

    </el-dialog>


  </el-row>
</template>

<script>
// import { getCodeImg } from "@/api/login";

// import { encrypt, decrypt } from '@/utils/jsencrypt'

import { mapState, mapMutations } from "vuex";

import toolsUtils from "@/common/toolsUtils.js"
import CryptoJS from "crypto-js"
import ToolsUtils from '../common/toolsUtils';
import { Message } from "element-ui";

import ossDataMixins from "../common/commonMixins/ossDataMixins";

export default {
  name: "Login",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }]
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
      tabIndex: 0,
      noticeMsg: "",
      pwdType: "password",
      dialogForgetPwd: false,
      customerServicePhone:""

    };


  },
  mixins: [ossDataMixins],
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    console.log(this.oss)
    //登录成功后 不能在跳到登陆页面
    if (this.isLogin) {
      this.$router.replace({
        path: "/"
      })
    }

    this.getCode();
    this.getCookie();
    this.getStudentInfo();


  },
  computed: {
    ...mapState(["isLogin"])
  },
  methods: {
    ...mapMutations(["saveLoginInfo"]),
    async getStudentInfo() {
      //去掉dev-api 这个上线后会更换 所以不写在代码里
      // let res = await this.$api.get("/web/frontUser/student/info");

    },
    getCode() {
      // getCodeImg().then(res => {
      //   this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
      //   if (this.captchaEnabled) {
      //     this.codeUrl = "data:image/gif;base64," + res.img;
      //     this.loginForm.uuid = res.uuid;
      //   }
      // });
    },
    getCookie() {
      const rememberMeInfo = toolsUtils.getCookiesSync("rememberMe");

      if (rememberMeInfo) {
        this.loginForm = {
          username: CryptoJS.AES.decrypt(rememberMeInfo.loginName, 'jfgas12444#####').toString(CryptoJS.enc.Utf8),
          password: CryptoJS.AES.decrypt(rememberMeInfo.password, 'jfgas12444#####').toString(CryptoJS.enc.Utf8),
          rememberMe: rememberMeInfo ? true : false
        };
      };

    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {


          let userInfo = {
            name: this.loginForm.username,
            pwd: this.loginForm.password
          }

          this.noticeMsg = "";

          let res = null;
          let apiUrl = "";
          if (this.tabIndex == 0) {
            //去掉dev-api 这个上线后会更换 所以不写在代码里

            apiUrl = "/web/frontUser/student/login"
          } else {
            apiUrl = "/web/frontUser/teacher/login"
          }

          res = await this.$api.post(apiUrl, {
            loginName: this.loginForm.username,
            password: this.loginForm.password
          })

          if (res.code == 200) {

            if (this.loginForm.rememberMe) {
              let rememberMeInfo = {
                loginName: CryptoJS.AES.encrypt(this.loginForm.username, 'jfgas12444#####').toString(),
                password: CryptoJS.AES.encrypt(this.loginForm.password, 'jfgas12444#####').toString()
              }
              toolsUtils.setCookiesSync('rememberMe', rememberMeInfo, 30);
            } else {
              toolsUtils.removeCookiesSync('rememberMe');
            }

            let tokenTmp = CryptoJS.AES.encrypt(res.data.frontUserToken, 'jfgas12444#####').toString()
			// user_info.userName+" "+user_info.loginName+"
            let userTmp = CryptoJS.AES.encrypt(JSON.stringify({ id: res.data.frontUser.id, role: this.tabIndex == 0 ? '0' : '1',userName:res.data.frontUser.userName,loginName:res.data.frontUser.loginName, }), 'jfgas12444#####').toString()

            toolsUtils.setCookiesSync('user_info', userTmp, this.loginForm.rememberMe ? 30 : 10);
            toolsUtils.setCookiesSync('user_token', tokenTmp, this.loginForm.rememberMe ? 30 : 10);
            toolsUtils.setStorageSync("accountLogin", "true");


            this.saveLoginInfo({ ...res.data.frontUser, role: this.tabIndex == 0 ? '0' : '1' });

            this.$router.push({
              path: "/"
            })


          } else {
            this.noticeMsg = res.msg;
            // this.$message({
            //   type: "warning",
            //   message: res.msg
            // })
          }

        }
      });
    },
    changeTab(index) {
      if (this.tabIndex == index) {
        return;
      }
      this.tabIndex = index;
    },
    lookpwd() {
      console.log(this.pwdType)
      this.pwdType = this.pwdType == "password" ? "text" : "password"

    },
    forgetPwd() {
      this.dialogForgetPwd = true;
    },
    toServer() {

    },
    async dialogForgetPwdOpen(){
      let res = await this.$api.get("web/frontUser/student/customerServicePhone");
      if(res.code == 200){
        this.customerServicePhone = res.data.customerServicePhone
      }else {
        Message({
          type: "error",
          message: res.msg
        })
      }


    }


  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  display: flex;

  height: 100vh;
  background-image: url("../static/login_bg.jpg");
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-title-box-col {
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: center;

  }
}

.login-title-box {
  margin-top: 153px;
  margin-left: 41px;
  width: 239px;
  height: 107px;

  // position: absolute;
  // left: 203px;
  @media screen and (max-width: 768px) {
    margin-top: 10px;
    margin-left: 0;
  }

}

.content-box {
  margin-top: 153px;
  width: 90%;
  box-sizing: border-box;
  margin-left: 64px;


  @media screen and (max-width: 768px) {
    margin-top: 10px;
    width: 100%;
    margin-left: 0;
  }

}

.content-box-item {
  box-sizing: border-box;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }

}

.notice-box {
  margin-top: 20px;
  width: 100%;
  position: absolute;
  color: #F56C6C;
  font-size: 20px;
}

.tab-box {
  width: 100%;
  position: relative;
  height: 78px;


  .tab-box-item {
	cursor: pointer;
    height: 78px;
    border-radius: 14px 14px 0 0;
    box-sizing: border-box;
    position: relative;
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 50px;
    letter-spacing: 0em;


    /* 绿 */
    color: #fff;

    .tab-box-item-left {
      background-color: #0AA26B;

      height: 78px;
      border-radius: 16px 11px 0 0;
    }

    .tab-box-item-left-actived {
      background-color: #fff;
    }

    .tab-box-item-left-shadow1 {
      box-shadow: -3px -8px 15px -3px rgba(107, 137, 127, 0.2);
    }

    .tab-box-item-left-shadow2 {
      box-shadow: 3px -8px 15px -3px rgba(107, 137, 127, 0.2);
      // box-shadow: 5px -5px 10px -4px red;
    }

    .tab-box-item-sanjiao {


      position: absolute;
      right: -14.8px;
      bottom: 0;
      margin-top: 10px;
      border-left: 18px solid #0AA26B;
      border-right: 17px solid transparent;
      border-top: 34px solid transparent;
      border-bottom: 38px solid #0AA26B;
    }

    .tab-box-item-sanjiao-actived {

      position: absolute;
      right: -14.8px;
      bottom: 0;
      margin-top: 10px;
      border-left: 18px solid #fff;
      border-right: 17px solid transparent;
      border-top: 34px solid transparent;
      border-bottom: 38px solid #fff;


    }

    .tab-box-item-sanjiao2 {

      position: absolute;
      left: -14.8px;
      bottom: 0;
      margin-top: 10px;
      border-left: 18px solid transparent;
      border-right: 18px solid #0AA26B;
      border-top: 33px solid transparent;
      border-bottom: 37px solid #0AA26B;
      z-index: 10;



    }

    .tab-box-item-sanjiao2-actived {

      position: absolute;
      left: -14.8px;
      bottom: 0;
      margin-top: 10px;
      border-left: 18px solid transparent;
      border-right: 18px solid #fff;
      border-top: 33px solid transparent;
      border-bottom: 37px solid #fff;
      z-index: 10;
    }

  }

  .tab-box-item-actived {
    color: #0AA26B;
  }
}


.login-form {
  box-sizing: border-box;
  border-radius: 0 0 12px 12px;
  background: #FFFFFF;
  padding: 60px 82px 57px 82px;
  box-shadow: -1px 1px 15px -6px rgba(107, 137, 127, 0.2), 1px 1px 15px -6px rgba(107, 137, 127, 0.2);


  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 60px 10px 57px 10px;
  }


  .login-from-title {

    font-family: 思源黑体;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;

    color: #696F79;
  }

  .input-box {
    height: 64px;
    border-radius: 100px;
    box-sizing: border-box;
    /* 绿 */
    border: 2px solid #0AA26B;
    box-sizing: border-box;
    padding-left: 24px;
    padding-right: 24px;

    .input-box-badge {
      width: 24px;
      height: 24px;
    }

  }

  .input-box2 {
    height: 64px;
    border-radius: 100px;
    opacity: 1;

    box-sizing: border-box;
    border: 1px solid rgba(10, 162, 107, 0.2);
  }

  .el-input {



    input {
      height: 24;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }

  .pwd-contrl-box {


    .pwd-contrl-box-text {
      font-family: 思源黑体;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      letter-spacing: 0em;
      /* 绿 */
      color: #0AA26B;

      &:hover {
        cursor: pointer;
      }
    }

  }


}

.submit-box {
  width: 100%;
  height: 64px;
  border-radius: 100px;
  opacity: 1;

  /* 绿 */
  background: #0AA26B;

  font-family: Inter;
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
  text-align: center;
  letter-spacing: 0em;

  color: #FFFFFF;
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-login-footer {
  line-height: 40px;
  position: absolute;
  // bottom: 196px;
  top: 126px;
  width: 100%;
  text-align: center;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
  z-index: 10;
  font-family: 思源黑体;
  font-size: 16px;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  color: #333333;


  @media screen and (max-width: 768px) {
    padding-top: 15px;
    top: 0px;
    position: relative;
    bottom: 0;
  }


}

.login-code-img {
  height: 38px;
}


/deep/ .el-input__inner {
  border: none;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0AA26B;
  border-color: #0AA26B;
}

/deep/ .el-checkbox__label {
  color: #333 !important;

  font-family: 思源黑体;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0em;

  /* 333333 */
  color: #333333;
}


.appraise-popup-title {
  width: 100%;
  height: 86px;
  border-radius: 20px 20px 0 0;
  background: #0AA26B;
  box-sizing: border-box;
  padding: 0 35px;

  .appraise-popup-title-name {
    font-family: 思源黑体;
    font-size: 26px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;

    font-feature-settings: "kern" on;
    /* 纯白 */
    color: #FFFFFF;
  }

  img {
    width: 56px;
    height: 56px;
  }
}

.start-popup-content {
  background: #fff;
  border-radius: 0 0 20px 20px;
  box-sizing: border-box;
  padding: 0 52px;

  .start-popup-content-text1 {

    margin-top: 89px;
    margin-bottom: 89px;
    font-family: 思源黑体;
    font-size: 22px;
    font-weight: normal;
    line-height: 40px;
    letter-spacing: 0em;

    font-feature-settings: "kern" on;
    /* 333333 */
    color: #333333;
  }

  .start-popup-content-timebox {
    margin-top: 30px;
    margin-left: 173.5px;

    span {
      margin-right: 30px;
      font-family: 思源黑体;
      font-size: 22px;
      font-weight: normal;
      line-height: 30px;
      letter-spacing: 0em;

      font-feature-settings: "kern" on;
      /* 333333 */
      color: #333333;
    }

    div {
      width: 195px;
      height: 64px;
      border-radius: 100px;
      opacity: 1;

      background: #E5F7F1;

      box-sizing: border-box;
      border: 1px solid rgba(10, 162, 107, 0.2);
    }

  }

  .start-popup-content-tipsbox {
    margin-top: 89px;
    margin-bottom: 75px;
    font-family: 思源黑体;
    font-size: 22px;
    font-weight: normal;
    line-height: 40px;
    letter-spacing: 0em;

    font-feature-settings: "kern" on;
    /* 确认开始学员 */
    color: #333333
  }

  .start-popup-content-line {
    margin-top: 30px;
    width:100%;
    height: 0px;
    opacity: 1;

    border: 1px solid rgba(10, 162, 107, 0.2);
  }

  .start-popup-content-btnsbox {
    margin-top: 31px;
    margin-bottom: 30px;
    width: 100%;

    div {
      &:first-child {
        margin-right: 20px;
        width: 230px;
        height: 64px;
        border-radius: 100px;
        /* 灰 */
        background: #ACBEB0;
        font-family: 思源黑体;
        font-size: 28px;
        font-weight: bold;
        line-height: 64px;
        text-align: center;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 纯白 */
        color: #FFFFFF;
      }


    }
  }

}



.server-box-content {
  margin-top: 21px;
  .server-box-content-badge {
    width: 235px;
    height: 313px;
    margin-right: 17px;
  }

  .server-box-content-textbox {
    span {
      display: inline-block;

      &:nth-child(1) {

        font-family: 思源黑体;
        font-size: 22px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;
        margin-bottom: 5px;
      }

      &:nth-child(2) {
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: bold;
        line-height: 40px;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 绿 */
        color: #0AA26B;
        margin-bottom: 30px;
      }

      &:nth-child(3) {

        font-family: 思源黑体;
        font-size: 22px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;

      }

    }


  }
}


.no-data {
  margin-top: 110px;
  width: 338px;
  height: 298px;
}



/deep/ .el-dialog__header {
  border-radius: 20px 20px 0 0;
  padding: 0;

}

/deep/ .el-dialog__body {
  border-radius: 20px;
  padding: 0;
}

/deep/ .el-dialog {
  background: transparent;
  border-radius: 20px;
  box-shadow: 0 0px 0px #ccc;

  @media screen and (min-width: 992px) {
    width: 44.114%;
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    width: 82.395%;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
  }




}
</style>
